import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { renderDataContract } from '../../templates/htmlRenderer';
import { generateIframeHTML } from './iframe-template';
import { dataContractDefinitionWidgetStyles } from './index.styles';

export type DataContractDefinitionWidgetProps = {
  definition: string;
};

export const DataContractDefinitionWidget = ({
  definition,
}: DataContractDefinitionWidgetProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    if (iframeRef.current) {
      const htmlContent = renderDataContract(definition);
      const fullHtmlContent = generateIframeHTML(htmlContent);

      // Use srcdoc instead of data URL to avoid CSP violations
      iframeRef.current.srcdoc = fullHtmlContent;
    }
  }, [definition]);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <Box sx={dataContractDefinitionWidgetStyles.container}>
      {isLoading && (
        <Box sx={dataContractDefinitionWidgetStyles.loadingOverlay}>
          <CircularProgress sx={dataContractDefinitionWidgetStyles.spinner} />
        </Box>
      )}
      <iframe
        ref={iframeRef}
        onLoad={handleIframeLoad}
        style={dataContractDefinitionWidgetStyles.iframe}
        title="Data Contract Display"
        sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
        role="presentation"
      />
    </Box>
  );
};
